import {
  EfsMelcoEfsModelsSchemaListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useDataSourceSelect } from "../../hooks/inputFormats/useDataSourceSelect";

type SelectProcessingConditionDataSourceProps = {
  name: string;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export const SelectProcessingConditionDataSource: React.FC<
  SelectProcessingConditionDataSourceProps
> = ({ name, dataAssignments }) => {
  const { t } = useTranslation();

  const dataSourceSelect = useDataSourceSelect(dataAssignments);

  return (
    <>
      <SelectField
        name={name}
        style={{ width: "100%" }}
        options={dataSourceSelect}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
      />
    </>
  );
};
